import React, { useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from "react-router-dom";
import myImage from '../boy.png';
import projectLogo from '../project_logo.png'
import '../stylesheets/Main.css';

const Toolbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = () => {
    localStorage.removeItem('accessToken');
    navigate('/login');
    setIsOpen(!isOpen);
  };

  const handleEditClick = () => {
    navigate('/profile');
    setIsOpen(!isOpen);
  };

  return (
    <div className="nav-toolbar-container">
      <img
        src={projectLogo}
        alt="Profile"
        style={{
          marginLeft: '60px',
          marginTop: '10px',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
      <div className="nav-toolbar-item">
        <img src={myImage} className="img-circle" alt="User Logo" />
        <ArrowDropDownIcon onClick={toggleDropdown} />
      </div>
      {isOpen && (
        <>
          <div className="dropdownnn-menu">
            <button onClick={(handleEditClick)}>Edit Profile</button>
            <button onClick={(handleClick)}>Sign Out</button>
          </div>
        </>
      )}
    </div>
  );
}

export default Toolbar;
